import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[smTrim]'
})
export class TrimDirective {

  constructor(private el: ElementRef) { }

  @HostListener('blur', ['$event.target.value'])
  onBlur(value: string) {
    this.el.nativeElement.value = value.trim();
  }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    // Prevent leading spaces
    const newValue = value.replace(/^\s+/, '');
    const trimmedValue = newValue.replace(/\s+/g, ' ');

    if (value !== trimmedValue) {
      this.el.nativeElement.value = trimmedValue;
    }
  }
}
